import React from "react";

import closeCircleFill from "@iconify/icons-eva/close-circle-fill";
import { Icon } from "@iconify/react/dist/offline";
import { type Theme } from "@mui/material/styles";

// ----------------------------------------------------------------------

export default function Chip(theme: Theme): any {
  return {
    MuiChip: {
      defaultProps: {
        deleteIcon: <Icon icon={closeCircleFill} />,
      },

      styleOverrides: {
        root: {
          lineHeight: 1,
          backgroundColor: theme.palette.button.nav.backgroundColorHover,
        },
        colorDefault: {
          "&.MuiChip-sizeMedium > .MuiChip-avatar, .MuiChip-avatarSmall": {
            color: theme.palette.text.secondary,
          },
        },
        outlined: {
          borderColor: theme.palette.grey[500_32],
          "&.MuiChip-colorPrimary": {
            borderColor: theme.palette.primary.main,
          },
          "&.MuiChip-colorSecondary": {
            borderColor: theme.palette.secondary.main,
          },
        },
      },
    },
  };
}
